import React, { Component } from "react";
import "./Modal.css";

/**
 * Reusable Modal component with show/hide functionality
 * Displays family member information in a modal dialog
 */
class Modal extends Component {
  render() {
    const { show, close, mydetail, age, incrementAge } = this.props;
    const details = { ...mydetail };

    return (
      <div>
        <div
          className="modal-wrapper"
          style={{
            visibility: show ? "visible" : "hidden",
            opacity: show ? "1" : "0",
            transform: show ? "translate(-50%, -50%) scale(1)" : "translate(-50%, -50%) scale(0.8)"
          }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-header"
          aria-describedby="modal-body"
        >
          <div className="modal-content shadow-lg">
            <div className="modal-header bg-primary text-white" id="modal-header">
              <div className="d-flex align-items-center">
                <i className="fas fa-user-circle fa-2x mr-3"></i>
                <div>
                  <h2 className="mb-0">Family Member Details</h2>
                  <small className="text-light">Enhanced Profile View</small>
                </div>
              </div>
              <button
                className="close-modal-btn btn btn-link text-white p-0"
                onClick={close}
                type="button"
                aria-label="Close modal"
              >
                <i className="fas fa-times fa-2x"></i>
              </button>
            </div>

            <div className="modal-body bg-light" id="modal-body">
              <div className="family-member-modal text-center">
                <div className="profile-section mb-4">
                  <div className="avatar-wrapper mb-3">
                    <div className="modal-avatar bg-primary text-white d-inline-flex align-items-center justify-content-center">
                      <i className="fas fa-user fa-3x"></i>
                    </div>
                  </div>

                  <h3 className="text-primary mb-3">
                    <i className="fas fa-birthday-cake mr-2"></i>
                    Current Age: <span className="badge badge-primary badge-lg">{age}</span>
                  </h3>

                  <div className="action-section mb-4">
                    <button
                      onClick={incrementAge}
                      className="btn btn-primary btn-lg px-4 shadow"
                      type="button"
                      aria-label={`Increment age, currently ${age}`}
                    >
                      <i className="fas fa-plus-circle mr-2"></i>
                      Increment Age: {age}
                    </button>
                  </div>
                </div>

                {/* Member details */}
                <div className="member-details">
                  <h4 className="text-primary mb-4">
                    <i className="fas fa-info-circle mr-2"></i>
                    Profile Information
                  </h4>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="detail-card bg-white p-4 rounded shadow-sm mb-3">
                        <i className="fas fa-tag fa-2x text-primary mb-2"></i>
                        <br />
                        <strong className="text-primary">Type</strong>
                        <br />
                        <span className="text-capitalize h5 text-dark">{details.type}</span>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="detail-card bg-white p-4 rounded shadow-sm mb-3">
                        <i className="fas fa-calendar-alt fa-2x text-primary mb-2"></i>
                        <br />
                        <strong className="text-primary">Age Category</strong>
                        <br />
                        <span className="h5 text-dark">{details.myage}</span>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="detail-card bg-white p-4 rounded shadow-sm mb-3">
                        <i className="fas fa-star fa-2x text-primary mb-2"></i>
                        <br />
                        <strong className="text-primary">Rashi</strong>
                        <br />
                        <span className="text-capitalize h5 text-dark">{details.rashi}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer bg-white text-center border-top">
              <div className="d-flex justify-content-between align-items-center w-100">
                <small className="text-muted">
                  <i className="fas fa-magic mr-1"></i>
                  Family Member Management System
                </small>
                <button
                  onClick={close}
                  className="btn btn-secondary"
                  type="button"
                >
                  <i className="fas fa-times mr-1"></i>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;